export const PATHS = {
  home: '/',
  dashboard: '/dashboard',
  login: '/login',
  admins: '/admins',
  users: '/users',
  userDetail: '/users/:id',
  help: '/help',
  helpDetail: '/help/:id',
} as const;
